import { createRootRoute, Outlet } from '@tanstack/react-router';
import { GlobalScoringBanner } from '@/components/scoring/GlobalScoringBanner';

export const Route = createRootRoute({
  component: () => (
    <>
      <GlobalScoringBanner />
      <Outlet />
    </>
  ),
});
